var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollateralBankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#6756FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1389_110887",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1389_110887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 22.1693V16.3359H13.8307V22.1693H12.1641ZM17.1641 22.1693V16.3359H18.8307V22.1693H17.1641ZM9.66406 14.6693V13.0026L17.9974 8.83594L26.3307 13.0026V14.6693H9.66406ZM9.66406 25.5026V23.8359H19.7057C19.7335 24.1276 19.7682 24.4089 19.8099 24.6797C19.8516 24.9505 19.9141 25.2248 19.9974 25.5026H9.66406ZM22.1641 19.0443V16.3359H23.8307V18.2109L22.1641 19.0443ZM24.6641 28.0026C23.7057 27.7665 22.9106 27.2144 22.2786 26.3464C21.6467 25.4783 21.3307 24.5165 21.3307 23.4609V21.3359L24.6641 19.6693L27.9974 21.3359V23.4609C27.9974 24.5165 27.6814 25.4783 27.0495 26.3464C26.4175 27.2144 25.6224 27.7665 24.6641 28.0026ZM24.0599 25.5026L26.9557 22.6276L26.0807 21.7526L24.0599 23.7318L23.2474 22.9193L22.3724 23.8151L24.0599 25.5026Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollateralBankIcon);
export default __webpack_public_path__ + "static/media/collateral-bank-icon.a76a3d4efa83d075b907d9fc1aad4ceb.svg";
export { ForwardRef as ReactComponent };